<template>
  <div ref="graphArea" class="w-full h-full overflow-hidden" />
</template>

<script>
import ApexCharts from 'apexcharts'

const GRAPH_COLOR = '#0097FF'

export default {
  name: 'LineGraphRenderer',
  props: {
    values: {
      type: Array,
      required: true
    },
    scale: {
      required: true
    }
  },
  data () {
    return {
      graphInitialized: false,
      chart: null,
      resizeObserver: null,
      resizeRaf: null
    }
  },
  mounted () {
    this.resizeObserver = new ResizeObserver(() => {
      // Throttle to one redraw per frame
      if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf)
      this.resizeRaf = requestAnimationFrame(() => {
        this.chart?.updateOptions({}, false, false)
      })
    })
    if (this.$refs.graphArea) this.resizeObserver.observe(this.$refs.graphArea)
  },
  beforeDestroy () {
    this.resizeObserver?.disconnect()
    if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf)
    this.chart?.destroy()
    this.chart = null
  },
  watch: {
    values: {
      handler () { this.initializeGraph() },
      immediate: true
    },
    scale () { this.initializeGraph() }
  },
  methods: {
    async initializeGraph () {
      await this.$nextTick()
      if (this.graphInitialized || !this.values?.length || !this.scale) return
      
      const [_, domainMax] = this.scale.domain()
      const options = {
        series: [{
          name: 'Total Active',
          data: this.values
        }],
        colors: [GRAPH_COLOR],
        chart: {
          type: 'line',
          height: '100%',
          toolbar: { show: false },
          zoom: { enabled: false },
          offsetY: 0,
          offsetX: 0,
          sparkline: { enabled: true },
          animations: { enabled: false },
          redrawOnWindowResize: false,
          redrawOnParentResize: false
        },
        stroke: {
          curve: 'smooth',
          width: 1,
          lineCap: 'round',
          dashArray: 2
        },
        grid: {
          show: false
        },
        dataLables: { enabled: false },
        tooltip: { enabled: false },
        legend: { enabled: false },
        yaxis: {
          show: false,
          min: 0,
          max: domainMax,
          forceNiceScale: false
        },
        xaxis: { type: 'numeric', labels: { show: false } }
      }
      this.$nextTick(() => {
        const chartContainer = this.$refs.graphArea
        this.chart = new ApexCharts(chartContainer, options)
        this.chart.render()
      })
      this.graphInitialized = true
    }
  }
}
</script>